import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Formik, Form } from 'formik';
import { Autocomplete, Checkbox, Container, FormControlLabel, IconButton, TextField, TextareaAutosize } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { sorunTipi, aksiyonSahibi } from '../../helpers/ProcessData';
import Textarea from '@mui/joy/Textarea';
import CloseIcon from '@mui/icons-material/Close';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useState, useEffect } from 'react';
import { uygunsuzlukTipi } from "../../helpers/ProcessData"
import { useSelector } from "react-redux"
import useArge from '../../hooks/useArge';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,

};

const AyakTaslamaModal = ({ open, handleClose, info, setInfo, materialCode, designCode, setSearchSorunTipi, searchSorunTipi }) => {

  const nowData = new Date()
  const currentdatetime = nowData.getDate() + "-" + (nowData.getMonth() + 1) + "-" + nowData.getFullYear()
  const currentTime = nowData.getHours() + ":" + nowData.getMinutes()

  const [isCheck, setIsCheck] = useState(false)


  const [searchUrunKodu, setSearchUrunKodu] = useState(null)
  const [searchRenkKodu, setSearchRenkKodu] = useState(null)

  const handleChange = (e, newValue, fieldName) => {
    // setInfo({ ...info, [e.target.name]: e.target.value, ['urun_kodu']: search ? search.MALZEMEKODU : ""  })

    // Autocomplete'ten gelen olaylar için
    if (fieldName) {
      setInfo(prevInfo => ({
        ...prevInfo,
        [fieldName]: newValue?.MALZEMEKODU || newValue || ""
      }));
    }
    // TextField'tan gelen olaylar için
    else if (e?.target) {
      const { name, value } = e.target;
      // setInfo(prevInfo => ({
      //   ...prevInfo,
      //   [name]: value
      // }));

      setInfo(prevInfo => {

        const newInfo = { ...prevInfo, [name]: value }

        if (isCheck && newInfo.oldData_date) {

          const dateStr = newInfo.oldData_date.split('T')
          const parts = dateStr[0].split('-')
          newInfo.date = `${parts[2]}-${parts[1]}-${parts[0]}`
          newInfo.time = dateStr[1]
        }
        else {

          newInfo.date = currentdatetime.toString()
          newInfo.time = currentTime.toString()
        }

        newInfo.uygunsuzlukOrani = (Number(newInfo.uygunsuzAdet) / Number(newInfo.kontrolAdet)).toFixed(2)

        return newInfo
      })

    }

  }


  const { getFireData, putFireData, postFireData } = useArge()
  const [desenCodes, setdesenCodes] = useState([])

  const handleSubmit = (e) => {

    e.preventDefault()

    if (info.id) {
      putFireData('AyakTaslama', info)
      getFireData("AyakTaslama")
    }
    else {
      postFireData("AyakTaslama", info)
      getFireData("AyakTaslama")
    }

    handleClose()

  }


  useEffect(() => {

    const data = designCode.map((item) => item.DESENKODU)
    const dataSort = data.sort()
    setdesenCodes(dataSort)

  }, [designCode])


  // checkbox fonksiyon
  const handleIsCheck = (e) => {
    const { checked } = e.target
    setIsCheck(checked)
  }

  // checkbox false yap ve date bilgisini temizle
  function handleIsCheck_Reset() {
    setIsCheck(false)
    setInfo({ ...info, ['oldData_date']: "" })
  }



  return (
    <div>

      <Modal
        keepMounted
        open={open}
        onClose={() => {
          handleClose()
          handleIsCheck_Reset()
        }}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box sx={style}>

          <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center' }}>

            <Typography id="keep-mounted-modal-title" variant="h6" component="h2" color="#000000">
              Ayak Taşlama
            </Typography>

            <IconButton onClick={() => {
              handleClose()
              handleIsCheck_Reset()
            }}>
              <HighlightOffIcon sx={{ color: '#C70039', fontSize: '28px' }} />
            </IconButton>
          </Box>


          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
            <FormControlLabel
              control={
                <Checkbox checked={isCheck} onChange={handleIsCheck} name="oldData" />
              }
              label="Geçmiş tarihli veri girişi"
            />
            {
              isCheck && <TextField
                name='oldData_date'
                id='oldData_date'
                type='datetime-local'
                onChange={handleChange}
              />
            }

          </Box>


          <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', gap: 2, overflow: 'scroll', maxHeight: '550px' }} component='form' onSubmit={handleSubmit}>


            <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>

              <Autocomplete
                fullWidth
                value={searchUrunKodu}
                name='urun_kodu'
                onChange={(event, newValue) => {
                  setSearchUrunKodu(newValue);
                  handleChange(event, newValue, 'urun_kodu')
                }}
                id="search-select-demo"
                options={materialCode}
                getOptionLabel={(option) => option.MALZEMEKODU}
                renderInput={(params) => <TextField required {...params} label="Ürün Kodu" />}
              />

              <Autocomplete
                fullWidth
                value={searchRenkKodu}
                name='renkkodu'
                onChange={(event, newValue) => {
                  setSearchRenkKodu(newValue);
                  handleChange(event, newValue, 'renkkodu')
                }}
                id="search-select-demo"
                options={desenCodes}
                getOptionLabel={(option) => option}
                renderInput={(params) => <TextField required {...params} label="Renk Kodu" />}
              />

            </Box>



            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
              <TextField
                required
                fullWidth
                label="Kontrol Adet"
                name="kontrolAdet"
                id="kontrolAdet"
                type="text"
                variant="outlined"
                value={info.kontrolAdet}
                onChange={handleChange}
              />
              <TextField
                required
                fullWidth
                label="Uygunsuz Adet"
                name="uygunsuzAdet"
                id="uygunsuzAdet"
                type="text"
                variant="outlined"
                value={info.uygunsuzAdet}
                onChange={handleChange}
              />
              <TextField
                disabled
                fullWidth
                label="Uygunsuz Oran"
                name="uygunsuzlukOrani"
                id="uygunsuzlukOrani"
                type="text"
                variant="outlined"
                value={info.uygunsuzlukOrani}
                onChange={handleChange}
              />
            </Box>

            <TextField
              fullWidth
              label="Makine Parametre Kontrolü"
              name="makineParametreKontrolu"
              id="makineParametreKontrolu"
              type="text"
              variant="outlined"
              value={info.makineParametreKontrolu}
              onChange={handleChange}
            />

            <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>


              <TextField
                fullWidth
                label="Ayak Taslama Suresi"
                name="ayakTaslamaSuresi"
                id="ayakTaslamaSuresi"
                type="text"
                variant="outlined"
                value={info.ayakTaslamaSuresi}
                onChange={handleChange}
              />

              <FormControl fullWidth>
                <InputLabel id="ayakYuzeyKontrolu">Ayak Yuzey Kontrolu</InputLabel>
                <Select
                  labelId="ayakYuzeyKontrolu"
                  id="ayakYuzeyKontrolu"
                  name='ayakYuzeyKontrolu'
                  label="ayakYuzeyKontrolu"
                  value={info?.ayakYuzeyKontrolu}
                  onChange={handleChange}
                >
                  <MenuItem value="OK">OK</MenuItem>
                  <MenuItem value="NOK">NOK</MenuItem>
                </Select>
              </FormControl>

            </Box>


            <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>

              <Autocomplete
                fullWidth
                value={searchSorunTipi}
                name='uygunsuzluktipi'
                onChange={(event, newValue) => {
                  setSearchSorunTipi(newValue);
                  handleChange(event, newValue, 'uygunsuzluktipi')
                }}
                id="search-select-demo"
                options={uygunsuzlukTipi}
                getOptionLabel={(option) => option.text}
                renderInput={(params) => <TextField {...params} label="Sorun Tipi" />}
              />

              {/* RESET BUTTON */}
              {/* select içinde selçilen değeri resetlemek için kullanılan buton */}
              {/* <Button variant='contained' size='small' sx={{ textTransform: 'none' }} onClick={() => setInfo(prevInfo => ({ ...prevInfo, uygunsuzluktipi: '' }))}>Reset</Button> */}
            </Box>

            <TextField
              multiline
              fullWidth
              label="Açıklama"
              name="aciklama"
              id="aciklama"
              type="text"
              variant="outlined"
              value={info.aciklama}
              onChange={handleChange}
            />


            <TextField
              fullWidth
              label="Vardiya Sorumlusu veya Operatör"
              name="vardiyasorumlusu"
              id="vardiyasorumlusu"
              type="text"
              variant="outlined"
              value={info?.vardiyasorumlusu}
              onChange={handleChange}
            />


            <Button
              variant='contained'
              fullWidth
              type='submit'
            >
              {info?.id ? "Update Data" : "Add New Data"}
            </Button>


          </Box>


        </Box>
      </Modal>
    </div>
  );
}

export default AyakTaslamaModal